import Record from '../Record'

export default class RegisterFormData extends Record {

	constructor (data = {}) {

		// Default values
		data = Object.assign({
			account_name: '',
			contact_email: '',
			password: '',
			password_confirm: ''
		}, data)

		super(data)
		return this._proxy
	}

	validation_schema = {
		account_name: [
			'required'
		],
		contact_email: [
			'required',
			[ 'isEmail', {}, 'Nem valid e-mail cím.' ]
		],
		password: [
			'required',
			[ 'isLength', { min: 8 }, 'A megadott jelszó nem elég hosszú. (Min. 8 karakter.)' ]
		],
		password_confirm: [
			'required'
		]
	}
}
